import React, { useState } from 'react';
import CachedIcon from '@mui/icons-material/Cached';
import CancelIcon from '@mui/icons-material/Cancel';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import Spinner from './spinner/Spinner';
import { axiosInstancev2 } from '../utils/Axios/axiosInterceptorv2';

function MoveCohortDropOffs({ cohortId, toggleModal, cohortName }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const queryClient = useQueryClient();

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    axiosInstancev2
      .post('/cohorts/students/move-to-drop-off-cohort', {
        cohort_id: cohortId,
      })
      .then((response_data) => {
        toast.success(
          response_data?.data?.success_message ||
            `Successfully moved ${cohortName} drop offs`
        );
        queryClient.invalidateQueries(['students', cohortId]);
        queryClient.invalidateQueries(['cohorts']);
        setIsSubmitting(false);
        toggleModal();
      })
      .catch((error) => {
        toast.error(
          `Failed to move ${cohortName} drop offs! Please try again. ${error?.response?.data?.error}`
        );
        setIsSubmitting(false);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };
  return (
    <form
      className="text-gray-700 space-y-4"
      onSubmit={(event) => handleSubmit(event)}
    >
      <p>
        Are you sure you want to move inactive students in the{' '}
        <strong>{cohortName} </strong> to the Drop-off cohort?
      </p>
      {isSubmitting ? (
        <div className="w-full flex align-middle justify-center items-center">
          <Spinner />
        </div>
      ) : (
        <div className=" flex justify-between mt-8">
          <button
            className={`border-[1px] border-claret-500 px-4 py-1 rounded-md text-claret-500 text-sm space-x-2 flex items-center `}
            type="button"
            onClick={toggleModal}
          >
            <CancelIcon fontSize="inherit" />
            <p>Cancel</p>
          </button>
          <button
            className={`bg-claret-500 px-4 py-1 rounded-md text-white text-sm space-x-2 flex items-center `}
            type="submit"
          >
            <CachedIcon fontSize="inherit" />
            <p>Move Cohort Drop-offs</p>
          </button>
        </div>
      )}
    </form>
  );
}

export default MoveCohortDropOffs;
